import React, { Fragment, useContext } from 'react'
import styled, { css } from 'styled-components'
import { CreationToolsContext } from '../../../manager'
import CreationTool from '../../../types/creation-tool'
import CreationToolUserRestriction from '../../../types/user-restriction'
import CreationToolWelcomeButton from '../../../types/welcome-button'
import Button from './button'

const Container = styled.div`
    background-image: repeating-linear-gradient(
            0deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.4) 8px,
            transparent 8px,
            transparent 16px,
            rgba(255, 255, 255, 0.4) 16px
        ),
        repeating-linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.4) 8px,
            transparent 8px,
            transparent 16px,
            rgba(255, 255, 255, 0.4) 16px
        ),
        repeating-linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.4) 8px,
            transparent 8px,
            transparent 16px,
            rgba(255, 255, 255, 0.4) 16px
        ),
        repeating-linear-gradient(
            270deg,
            rgba(255, 255, 255, 0.4),
            rgba(255, 255, 255, 0.4) 8px,
            transparent 8px,
            transparent 16px,
            rgba(255, 255, 255, 0.4) 16px
        );
    background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;
    background-position: 0 0, 0 0, 100% 0, 0 100%;
    background-repeat: no-repeat;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 -8px 40px;
    padding: 2px;
`

const Row = styled.div`
    display: flex;
    width: 100%;
`

const Divider = styled.div<{ horizontal?: boolean }>`
    background-image: repeating-linear-gradient(
        ${props => (props.horizontal ? '90deg' : '0deg')},
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0.4) 8px,
        transparent 8px,
        transparent 16px,
        rgba(255, 255, 255, 0.4) 16px
    );
    background-size: 2px 100%;
    background-position: 0 0;
    background-repeat: no-repeat;
    flex-shrink: 0;
    width: 2px;

    ${props =>
        props.horizontal &&
        css`
            background-size: 100% 2px;
            height: 2px;
            width: 100%;
        `}
`

type Props = {
    className?: string
}

const CreationToolsWelcomeButtons = ({ className }: Props) => {
    const { tool, userRestrictionAccess } = useContext(CreationToolsContext)
    const buttons = CreationTool.welcomeButtons(tool)

    // filter out any buttons that have a user restriction
    const filteredButtons = buttons.filter(button => {
        const restriction = CreationToolWelcomeButton.userRestriction(button)
        // filter out any buttons with restrictions not supported by current user
        return !restriction || CreationToolUserRestriction.hasAccess(restriction, userRestrictionAccess)
    })

    return (
        <Container className={className}>
            <Row>
                {filteredButtons.map((button, i) => (
                    <Fragment key={button}>
                        <Button button={button} />
                        {i < filteredButtons.length - 1 ? <Divider /> : null}
                    </Fragment>
                ))}
            </Row>
        </Container>
    )
}

export default CreationToolsWelcomeButtons
